import React, { useState } from 'react';
import { 
  Box, Typography, List, ListItem, ListItemAvatar, 
  ListItemText, Avatar, Paper, Stack, Divider, Fade,
  ListItemButton, TextField, InputAdornment 
} from '@mui/material';
import { Https, WarningAmber, InfoOutlined, Search } from '@mui/icons-material';

export const SSLMonitor = ({ sslData = [] }) => {
  const [selected, setSelected] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const getDaysRemaining = (dateString) => {
    if (!dateString) return 0;
    const expiry = new Date(dateString);
    const now = new Date();
    return Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
  };

  // Filter and then Sort
  const processedData = Array.isArray(sslData) 
    ? [...sslData]
        .filter(item => 
            item.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
            item.cid.toString().includes(searchQuery)
        )
        .sort((a, b) => new Date(a.expiration_date) - new Date(b.expiration_date))
    : [];

  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid #E2E8F0', height: '100%', bgcolor: '#fff' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 900, color: '#1A3A3F', fontSize: '0.8rem' }}>
          SSL MONITOR
        </Typography>
        
        <TextField
          size="small"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ 
            width: '140px', 
            '& .MuiInputBase-input': { fontSize: '0.75rem', py: 0.5 },
            '& .MuiOutlinedInput-root': { borderRadius: '6px' }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ fontSize: 16 }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <List sx={{ height: 280, overflowY: 'auto', pr: 0.5 }}>
        {processedData.length > 0 ? processedData.map((item) => {
          const days = getDaysRemaining(item.expiration_date);
          const color = days <= 7 ? '#ef4444' : days <= 30 ? '#f59e0b' : '#10b981';

          return (
            <ListItem key={item.cid} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton 
                onClick={() => setSelected(item)}
                selected={selected?.cid === item.cid}
                sx={{ 
                  borderRadius: '6px',
                  py: 0.5,
                  px: 1,
                  border: selected?.cid === item.cid ? `1px solid ${color}` : '1px solid #f8fafc',
                  bgcolor: selected?.cid === item.cid ? `${color}08 !important` : 'transparent',
                }}
              >
                <ListItemAvatar sx={{ minWidth: 40 }}>
                  <Avatar sx={{ bgcolor: `${color}15`, color: color, width: 28, height: 28 }}>
                    <Https sx={{ fontSize: 14 }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary={<Typography sx={{ fontSize: '0.75rem', fontWeight: 800, color: '#1e293b' }}>{item.name}</Typography>}
                  secondary={`CID: ${item.cid}`}
                  secondaryTypographyProps={{ sx: { fontSize: '0.65rem', fontWeight: 600 } }}
                />
                <Box sx={{ textAlign: 'right' }}>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: color, lineHeight: 1 }}>{days}d</Typography>
                  <Typography sx={{ fontSize: '0.55rem', color: '#94a3b8', fontWeight: 700 }}>LEFT</Typography>
                </Box>
              </ListItemButton>
            </ListItem>
          );
        }) : (
            <Box sx={{ textAlign: 'center', py: 5 }}>
                <Typography variant="caption" color="textSecondary">No matches found.</Typography>
            </Box>
        )}
      </List>

      <Divider sx={{ my: 1.5 }} />

      {selected ? (
        <Fade in={!!selected}>
          <Box sx={{ p: 1.5, bgcolor: '#F8FAFC', borderRadius: '6px', border: '1px solid #E2E8F0' }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                <InfoOutlined sx={{ fontSize: 14, color: '#2F727C' }} />
                <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: '#475569' }}>EXPIRATION TIMESTAMP</Typography>
            </Stack>
            <Typography sx={{ fontSize: '0.75rem', color: '#1A3A3F', fontFamily: 'monospace', fontWeight: 700 }}>
                {new Date(selected.expiration_date).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
            </Typography>
          </Box>
        </Fade>
      ) : (
        <Typography sx={{ fontSize: '0.65rem', color: '#94a3b8', textAlign: 'center', display: 'block' }}>
            Select an item for full details
        </Typography>
      )}
    </Paper>
  );
};